import React from "react";
import { usePlacesWidget } from "react-google-autocomplete";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/useApi";
import AviableAddress from "../../utils/useAviableAddress";
import {
  StoreDetailAddress,
  StoreSameDayService,
  StoreSelectedLocation,
  SystemStoreBasketAddress,
  SystemStoreStar,
} from "../../utils/useStorage";
import {
  STYLE_ABSOLUTE_OBJECT_CENTER,
  STYLE_BODY_3_REGULAR,
  STYLE_BORDER_BLUE_ADDRESS,
  STYLE_BOTTOM_BAR,
  STYLE_BUTTON_BLUE,
  STYLE_BUTTON_BLUE_DISABLED,
  STYLE_COLSPAN_ADDRESS,
  STYLE_COLSPAN_ADDRESS_BASKET,
  STYLE_HEADING_3_BOLD_24_18,
  STYLE_HEADING_3_BOLD_24_18_TH,
  STYLE_HEIGHT_BAR,
  STYLE_ICON_ADDRESS,
  STYLE_LOCATION_NAVBAR_PLACEHOLDER_LOCATION,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_NO_MB,
  STYLE_PARENT_DELETE_PROGRAM,
  STYLE_PARENT_SELECT_ADDRESS,
  STYLE_PARENT_SELECT_ADDRESS_BASKET,
  STYLE_SAVED_ADDRESSES,
  STYLE_SUBTITLE_SEMIBOLD,
  STYLE_TITLE_MEDIUM,
  STYLE_TWOBUTTON_ADDRESS,
} from "../../utils/useStyle";
import "./Address.Style.css";
import Container from "../../components/layouts/Container";
import { FunctionSetSelectedLocationFromLatLng } from "./functions/Address.OnClickCurrentLocation";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Polyline,
  InfoWindow,
} from "react-google-maps";
import { ContextLanguage } from "../../context/Context.Language";
import { useIsMobile } from "../../utils/useIsMobile";
import { useWindowSize } from "../../utils/useWindowSize";
import { ProgramGoBackMap } from "../task/render/Program.GoBack";

import {
  lineBangkok,
  linePattaya,
} from "../../components/googleMap/GoogleMap.Main";
import {
  MAX_TEXT_LENGTH,
  TEXT_ADDRESS_SEARCH,
  TEXT_CANCEL,
  TEXT_CONFIRM,
  TEXT_PLACEHOLDER_ADDRESS_DETAIL,
  TEXT_PLACEHOLDER_ADDRESS_NAME,
  TEXT_PRIMARY,
} from "../../utils/useConstants";
import { ContextCart } from "../../context/Context.Cart";
import { useLocation, useNavigate } from "react-router-dom";
import useAutosizeTextArea, {
  AwaitComponent,
} from "../../utils/useAutosuzeTextArea";
import { AddressMarker } from "../../components/bar/Bottom.Bar";
import SwitchCeles from "../../components/attributes/SwitchCeles";
import { BlueButton } from "../../components/attributes/Button";
import { DeclareState } from "radium-omnibus";
import AddressCreateMyLocation from "./functions/Address.CreateMyLocation";
import NavbarClickLocationSearch from "../../components/layouts/functions/Navbar.ClickLocationSearch";
import { TEXT_SAVED_ADDRESSES } from "../../utils/useConstants";
import { TEXT_DELETE } from "../../utils/useConstants";
import TemplateModal from "../../components/template/Template.Modal";
import { TEXT_DELETE_ADDRESS } from "../../utils/useConstants";
import { TEXT_QUESTION_DELETE } from "../../utils/useConstants";
import { TYPE_HOME } from "../../utils/useConstants";
import {
  ICON_ADDRESS_LOCATION,
  ICON_HOME_ADDRESS,
  ICON_LOCATION,
  ICON_WORK_ADDRESS,
} from "../../utils/useIcons";
import { TYPE_WORK } from "../../utils/useConstants";
import { TYPE_OTHER } from "../../utils/useConstants";
import { CONSTANT_LANGUAGE } from "../../utils/useConstants";
import { TEXT_PRIMARY_ADDRESS } from "../../utils/useConstants";
import { TEXT_EDIT } from "../../utils/useConstants";
import OurserviceFirstLoad from "../select/functions/Ourservice.FirstLoad";
import { initAuth } from "../../redux/auth.reducer";

const areas = AviableAddress;

const googleMapsKey = "AIzaSyBEfEiS-b6u12_-O2Ng_UeJlYLEOrWGOfA";

var googleMapURL = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&v=3.exp&libraries=geometry,drawing,places`;

// const markerIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAYAAADi1poDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAppJREFUeNrMWEuOozAQJUn3ZKZXHMGLrLLiCByBIzA34AjcgHVWzA2YA0QikUaa7Mh+FuQEgdUsppuudo0cyQLb2MFu8qQnlA/2c1XZVWXPswfizYiIMqesKEHAhrKkTFwK9SlTNhkYEsWFti1yj5A+C7awScgtCOm7M5BNthhxUal6GbHZbC7b7bZdr9ctfm6aJtjv961G7Hyn/GFimUK2SkII7Ha75nq9NiDB6XSq4zges1agKyYVDeD7PmRZBiao6xrCMFS5bzSmApmYqqrgXiisVYwJKm2L0RAVGlmnKAqwARrwEASBkZUGWxz9bxNlWcqsJIyl2pV1eEisFIuS4yB2XAB3qkAQesdbqrI1XYmTpCgZl/QFDXxI48eJINW4y94Omx28oEP/x7ZtnUx6uVy0BA1wPp+dCFKNywsa/OtwODix0vF4FOrUOodMk6kO8DgRbPtIJCgTlRp45NtCmqZGWZ+IjnVMijaACVpindy4ZM3z3FVihbHqksgKejT3vZZRiMl0NkIsKzsx+5vURrgIiZuA9XXaXYiy24ii6L8bsUQVlRhJkqiE3ALZuIm03QJptUJjSCyLqWy017FFMb6tEz95JDFTY2pSzIyhukNQ5LKGIoY3IZn3CdCNp9pF3Gh3uCYdqZNaXeNy6tOh2nWzXIISiZh8zs4lfxTryGKpfIT+rlZdGsyBhEsR1jrXKbh1vT+9B0Jtw11PE617I953/6L8TbmmfGcE9tTGylDEgi0CJ/1K+Y3xhfIv5R/2G/KZjX+7nAfdCUyAk3xhfOaeT9zi3ihfOf7j2Nl02aLHJfdcsbGAc1MneMdqDAFbPe+Cjn235HbsO/c9b6nOhcv4gF4x8oHt9SzUcQHuuRSkGgemDPQhwAC3qLvGM4GyJgAAAABJRU5ErkJggg==`;
// const markerIcon = `data:image/png;base64,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`;

const markerIcon = `data:image/png;base64,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`;
const InfoConfirmContainer = ({ children }) => {
  return <div className="  w-auto p-2 ">{children}</div>;
};

const GoogleMapsWrapper = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      {...props}
      ref={(c) => {
        props.onMapMounted && props.onMapMounted(c);
      }}
    >
      {props.children}
    </GoogleMap>
  ))
);

const ModalDetelet = ({ id, FunctionLoadMyAddress, row }) => {
  const [open, setOpen] = React.useState(false);
  const { language } = React.useContext(ContextLanguage);

  const selectedLocation = StoreSelectedLocation(
    (state) => state.selectedLocation
  );
  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );
  const address = SystemStoreBasketAddress((state) => state.address);
  const setAddress = SystemStoreBasketAddress((state) => state.setAddress);
  const setDetailAddress = StoreDetailAddress(
    (state) => state.setDetailAddress
  );

  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        className={`${
          language === "TH"
            ? " text-md-th md:text-base-th "
            : " text-md md:text-base "
        } text-laundry-red-100   font-semibold cursor-pointer hover:text-laundry-gray-80`}
      >
        {TEXT_DELETE[language]}
      </div>
      {open && (
        <TemplateModal
          acceptText={
            <div
              className={`${language === "TH" ? "text-base-th" : "text-base"}`}
            >
              {TEXT_DELETE[language]}
            </div>
          }
          cancelText={
            <div
              className={`${language === "TH" ? "text-base-th" : "text-base"}`}
            >
              {TEXT_CANCEL[language]}
            </div>
          }
          save={async (e) => {
            e.stopPropagation();
            if (selectedLocation?.reference === row?.reference) {
              setSelectedLocation(false);
            }
            if (address?.reference === row?.reference) {
              setAddress(false);
            }

            const isDeleteSeletedLocation =
              selectedLocation?.reference === row?.reference;

            if (isDeleteSeletedLocation) {
              setDetailAddress("");
            }
            // console.log("isDeleteSeletedLocation", {
            //   isDeleteSeletedLocation,
            //   row,
            //   selectedLocation,
            //   address,
            //   id,
            // });

            await api.delete(`/address/${id}`);
            FunctionLoadMyAddress();
            dispatch(initAuth());
            OurserviceFirstLoad();
          }}
          showCloseButton={true}
          showSaveButton={true}
          open={open}
          setOpen={setOpen}
          panel={
            <div
              className={`${STYLE_PARENT_DELETE_PROGRAM} ${
                language === "TH" ? "font-NotoSansThai" : "font-Poppins"
              }  `}
            >
              <div
                className={`${
                  language === "TH"
                    ? STYLE_HEADING_3_BOLD_24_18_TH
                    : STYLE_HEADING_3_BOLD_24_18
                } text-center h-h_30 `}
              >
                {TEXT_DELETE_ADDRESS[language]}
              </div>
              <div
                className={` py-3 md:pt-6 h-h_50 text-laundry-gray-80 text-center ${STYLE_BODY_3_REGULAR(
                  language
                )}`}
              >
                {TEXT_QUESTION_DELETE[language]}
              </div>
            </div>
          }
        />
      )}
    </React.Fragment>
  );
};

const AddressRenderMyAddress = ({
  row,
  index,
  language,
  location,
  setTab,
  navigate,
  FunctionLoadMyAddress,
  setIsStar = false,
}) => {
  const lineRef = React.useRef(null);

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const setAddress = SystemStoreBasketAddress((state) => state.setAddress);

  const setDetailAddress = StoreDetailAddress(
    (state) => state.setDetailAddress
  );

  React.useEffect(() => {
    if (lineRef?.current) {
      lineRef.current.style.width = `${lineRef.current.offsetWidth + 48}px`;
    }
  }, []);

  return (
    <div className="relative">
      <div
        onClick={() => {
          setAddress(row);
          setDetailAddress(row?.detail);
          setIsStar(false);
          navigate("/Basket");
        }}
        key={index}
        className={`${
          location.pathname === "/Basket"
            ? STYLE_PARENT_SELECT_ADDRESS_BASKET
            : STYLE_PARENT_SELECT_ADDRESS
        } + ${setTab ? " cursor-pointer " : " "} items-start `}
      >
        <div
          className={`bg-laundry-primary-blue w-[26px] h-[26px] rounded-full  mt-[9px] flex-none`}
        >
          {(row?.type === TYPE_HOME && (
            <ICON_HOME_ADDRESS className={STYLE_ICON_ADDRESS} />
          )) ||
            (row?.type === TYPE_WORK && (
              <ICON_WORK_ADDRESS className={STYLE_ICON_ADDRESS} />
            )) ||
            (row?.type === TYPE_OTHER && (
              <ICON_ADDRESS_LOCATION className={STYLE_ICON_ADDRESS} />
            ))}
        </div>
        <div
          className={`${STYLE_SUBTITLE_SEMIBOLD(language)} ${
            location.pathname === "/Basket"
              ? STYLE_COLSPAN_ADDRESS_BASKET
              : STYLE_COLSPAN_ADDRESS
          }  <1>`}
        >
          <div className={`  space-x-4 -mb-1 <1>`}>
            {row?.title ? (
              <span
                className={`md:group-hover:underline w-fit break-all ${
                  row?.primary
                    ? "text-laundry-primary-blue "
                    : " text-laudry-gray-200"
                } ${
                  language === CONSTANT_LANGUAGE.TH
                    ? " font-NotoSansThai "
                    : " font-Poppins "
                } `}
              >
                {row?.title}
              </span>
            ) : (
              <React.Fragment />
            )}
            {row?.primary ? (
              <span
                className={` ${
                  language === CONSTANT_LANGUAGE.TH
                    ? " font-NotoSansThai text-sm-th "
                    : "font-Poppins text-sm "
                }  font-medium text-laundry-primary-blue `}
              >
                {TEXT_PRIMARY_ADDRESS[language]}
              </span>
            ) : (
              <div className="h-1"></div>
            )}
          </div>
          <div
            className={`${
              language === "TH"
                ? " text-13-th md:text-sm-th "
                : " text-13 md:text-sm "
            } text-laundry-gray-80 font-normal leading-6`}
          >
            {" "}
            {row?.name}{" "}
          </div>
          <div
            className={`${
              language === "TH"
                ? " text-13-th md:text-sm-th "
                : " text-13 md:text-sm "
            } text-laundry-gray-80 font-normal leading-5 `}
          >
            {" "}
            {row?.where}{" "}
          </div>

          <div
            className={`${
              language === "TH" ? " text-sm-th " : " text-sm "
            } text-laundry-gray-100 mt-[6px] md:mt-3 font-normal leading-5`}
          >
            {row?.detail}
          </div>
        </div>

        <div className="flex flex-col ml-auto">
          <div
            className={`${
              language === "TH"
                ? " text-md-th md:text-base-th "
                : " text-md md:text-base "
            } mt-1 ml-auto cursor-pointer font-semibold   text-laundry-primary-blue  hover:text-laundry-gray-80 w-fit`}
            onClick={(e) => {
              e.stopPropagation();
              // if (setTab) {
              //   // RouterGetHistory(setHistory, STATE_CONSTANTS_ADDRESS.SELECT);
              setSelectedLocation({
                ...row,
                isAvailable: true,
              });
              if (setIsStar) {
                setIsStar(true);
              }

              setDetailAddress(row?.detail);

              OurserviceFirstLoad();
              //   setTab(STATE_CONSTANTS_ADDRESS.FOUND);
              // } else {
              //   navigate("/Address");
              // }
            }}
          >
            {TEXT_EDIT[language]}
          </div>
          <ModalDetelet
            id={row?._id}
            row={row}
            FunctionLoadMyAddress={FunctionLoadMyAddress}
          />
        </div>
      </div>
      <div
        ref={lineRef}
        className="absolute -left-6 border-b border-gray-200  w-full "
      />
    </div>
  );
};

const BottomBarAddress = ({ title, refetch, isStar, setIsStar }) => {
  const { language } = React.useContext(ContextLanguage);
  const { user } = useSelector((state) => state.auth);
  const [isConfirm, setIsConfirm] = React.useState(false);
  const [name, setName] = React.useState("");
  // const [description, setDescription] = React.useState("");

  const detailAddress = StoreDetailAddress((state) => state.detailAddress);
  const setDetailAddress = StoreDetailAddress(
    (state) => state.setDetailAddress
  );

  const isMobile = useIsMobile();
  const { cart } = React.useContext(ContextCart);

  const [isPrimary, setIsPrimary] = React.useState(false);

  const selectedLocation = StoreSelectedLocation(
    (state) => state.selectedLocation
  );
  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const setAddress = SystemStoreBasketAddress((state) => state.setAddress);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const setSameDayService = StoreSameDayService(
    (state) => state.setSameDayService
  );

  // const isFav = isStar || selectedLocation?._id

  const myOwnAddress =
    user?.address?.length > 0
      ? user?.address?.findIndex(
          (item) => item?.place_id === selectedLocation?.place_id
        ) > -1
      : false;

  const isFav = isStar;

  React.useEffect(() => {
    if (myOwnAddress) {
      // setDescription(selectedLocation?.detail);
      // setDetailAddress(selectedLocation?.detail);
      setName(selectedLocation?.title);
      setIsPrimary(selectedLocation?.primary);
    } else {
      // setDescription("");
      // setDetailAddress("");
      setName("");
      setIsPrimary("");
    }
  }, [myOwnAddress, selectedLocation]);

  React.useEffect(() => {
    if (!isStar && !myOwnAddress && !user) {
      // setDescription("");
      setDetailAddress("");
      setName("");
      setIsPrimary("");
    }
  }, [isStar, myOwnAddress, user]);

  const textAreaRef = React.useRef();

  useAutosizeTextArea(
    textAreaRef.current,
    detailAddress,
    0,
    selectedLocation?.isAvailable ? true : false,
    language,
    isStar
  );

  // useAutosizeTextArea(textAreaRef2.current, name, 56);

  if (selectedLocation?.name === "Loading...") {
    return <div></div>;
  }

  return (
    <div className="bg-white  mt-auto mb-10 md:mb-0">
      {selectedLocation?.isAvailable ? (
        <div
          className={`w-full px-4 md:px-10 xl:px-padding_read pt-4 md:pt-0 md:pb-8 bg-white max-w-desktop mx-auto -mt-2`}
        >
          {isFav && (
            <div
              className={`bg-white  border border-laudry-stroke rounded-lg w-full ${
                isMobile ? " h-[50px] " : " h-[52px] "
              } flex justify-center items-center mt-3 md:mt-4 mb-3 md:mb-4 `}
            >
              {/* <input
                className={` bg-transparent w-full  px-3 h-12 border-b-transparent focus:outline-none text-laundry-gray-100 font-normal ${
                  language === "TH"
                    ? " font-NotoSansThai text-13-th md:text-base-th  "
                    : " font-Poppins text-13  md:text-base  "
                }`}
            
                placeholder={TEXT_PLACEHOLDER_ADDRESS_NAME[language]}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              /> */}

              <input
                className={`${
                  language === "TH"
                    ? " placeholder:text-13-th md:placeholder:text-base-th  "
                    : " placeholder:text-13 md:placeholder:text-base "
                } bg-transparent w-full  px-3 h-fit border-b-transparent focus:outline-none text-laundry-gray-100 font-normal`}
                style={{
                  fontFamily: /^[\u0E00-\u0E7F]*$/.test(
                    String(name)?.replace(/ /g, "")
                  )
                    ? "Noto Sans Thai"
                    : "Poppins",
                  //if thai font and isMobile font size 15 else 18 and english font size 13 and 16
                  fontSize:
                    /^[\u0E00-\u0E7F]*$/.test(
                      String(name)?.replace(/ /g, "")
                    ) && isMobile
                      ? "15px"
                      : /^[\u0E00-\u0E7F]*$/.test(
                          String(name)?.replace(/ /g, "")
                        ) && !isMobile
                      ? "18px"
                      : !/^[\u0E00-\u0E7F]*$/.test(
                          String(name)?.replace(/ /g, "")
                        ) && isMobile
                      ? "13px"
                      : "16px",
                }}
                placeholder={TEXT_PLACEHOLDER_ADDRESS_NAME[language]}
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </div>
          )}
          {selectedLocation?.isAvailable && (
            <AddressMarker setIsStar={setIsStar} isStar={isFav} />
          )}

          <textarea
            maxLength={MAX_TEXT_LENGTH}
            style={{
              overflow: "hidden",
              resize: "none",
              display: isFav ? "block" : "none",
              fontFamily: /^[\u0E00-\u0E7F]*$/.test(
                String(detailAddress)?.replace(/ /g, "")
              )
                ? "Noto Sans Thai"
                : "Poppins",
              //if thai font and isMobile font size 15 else 18 and english font size 13 and 16
              fontSize:
                /^[\u0E00-\u0E7F]*$/.test(
                  String(detailAddress)?.replace(/ /g, "")
                ) && isMobile
                  ? "15px"
                  : /^[\u0E00-\u0E7F]*$/.test(
                      String(detailAddress)?.replace(/ /g, "")
                    ) && !isMobile
                  ? "18px"
                  : !/^[\u0E00-\u0E7F]*$/.test(
                      String(detailAddress)?.replace(/ /g, "")
                    ) && isMobile
                  ? "13px"
                  : "16px",
            }}
            ref={textAreaRef}
            value={detailAddress}
            className={` ${
              language === "TH"
                ? " placeholder:text-13-th md:placeholder:text-base-th "
                : " placeholder:text-13 md:placeholder:text-base "
            }  w-full  border border-laudry-stroke rounded-md text-laundry-gray-100 font-normal h-12 p-p_14 md:py-2 px-3   focus:outline-none  leading-5 md:leading-6 `}
            // className={` ${
            //   language === "TH"
            //     ? " font-NotoSansThai text-13-th md:text-base-th "
            //     : " font-Poppins text-13 md:text-base "
            // }  w-full  border border-laudry-stroke rounded-md text-laundry-gray-100 font-normal h-12 p-p_14 md:py-2 px-3   focus:outline-none  leading-5 md:leading-6 `}
            // placeholder={TEXT_PLACEHOLDER_ADDRESS_DETAIL[language]}
            placeholder={
              // TEXT_PLACEHOLDER_ADDRESS_DETAIL[language]
              language === "TH"
                ? `บอกสิ่งที่เราต้องรู้เกี่ยวกับออเดอร์ของคุณที่นี่เลย! ด้วยบริการรับและส่งคืนแบบไร้การสัมผัส คุณไม่ต้องรอรับส่งด้วยตัวเอง เราไปรับได้ทุกที่ที่ระบุไว้ เช่น หน้าประตูบ้าน จุดรับส่งของคอนโด รปภ. เป็นต้น`
                : `Please add any order details HERE and enjoy the convenience of our fully contactless service: You do not need to be present for pick up or return! Just specify the place for us e.g. hotel lobby, reception, drop-off table, etc.`
            }
            onChange={(e) => {
              setDetailAddress(e.target.value);
            }}
          />
          {isFav && (
            <div className={`flex justify-between my-4 md:mt-3 md:mb-5 `}>
              <div
                className={
                  ` ${
                    language === "TH"
                      ? " text-sm-th md:text-base-th "
                      : " text-sm md:text-base "
                  } font-semibold my-auto ` +
                  `${
                    isPrimary
                      ? " text-laundry-gray-100 "
                      : "  text-laundry-gray-30 "
                  }`
                }
              >
                {TEXT_PRIMARY[language]}
              </div>
              <SwitchCeles setValue={setIsPrimary} value={isPrimary} />
            </div>
          )}

          {isConfirm ? (
            <BlueButton
              classNameBottomBar={STYLE_HEIGHT_BAR}
              title={title}
              onClick={() => {
                setIsConfirm(true);
              }}
              className={`${STYLE_BUTTON_BLUE(language)} `}
            />
          ) : (
            <React.Fragment>
              {isFav ? (
                <div className={STYLE_TWOBUTTON_ADDRESS}>
                  <div
                    style={{
                      height: isMobile ? "50px" : "100%",
                    }}
                    onClick={() => {
                      // setTab(STATE_CONSTANTS_ADDRESS.SELECT);
                      setIsStar(false);
                      setSelectedLocation(false);
                    }}
                    className={`cursor-pointer ${STYLE_BORDER_BLUE_ADDRESS(
                      language
                    )}`}
                  >
                    {TEXT_CANCEL[language]}
                  </div>
                  <DeclareState
                    name="confirm-state"
                    initalState={false}
                    body={({ state, setState }) => {
                      return (
                        <div
                          style={{
                            height: isMobile ? "50px" : "100%",
                          }}
                          onClick={() => {
                            AddressCreateMyLocation(
                              name,
                              detailAddress,
                              selectedLocation,
                              user,
                              refetch,
                              isPrimary,
                              dispatch,
                              setSelectedLocation,
                              setState,
                              state,
                              navigate,
                              setAddress,
                              setIsStar
                            );
                          }}
                          className={`${
                            state
                              ? " bg-laundry-bglight "
                              : " bg-laundry-primary-blue "
                          }  ${
                            language === "TH"
                              ? " text-sm-th xl:text-base-th "
                              : " text-sm xl:text-base "
                          } cursor-pointer w-full   rounded-lg text-white font-semibold   hover:bg-laundry-gray-80 hover:order-blue  focus:outline-none  flex justify-center items-center  `}
                        >
                          {TEXT_CONFIRM[language]}
                        </div>
                      );
                    }}
                  />
                </div>
              ) : (
                <React.Fragment>
                  {selectedLocation?.isAvailable && (
                    <BlueButton
                      className={`${STYLE_BUTTON_BLUE(language)} `}
                      classNameBottomBar={STYLE_HEIGHT_BAR}
                      onClick={() => {
                        if (selectedLocation.location === "PATTAYA") {
                          setSameDayService(false);
                        }
                        setAddress(selectedLocation);
                        const thisIndex = user?.address?.findIndex(
                          (item) =>
                            item?.place_id === selectedLocation?.place_id
                        );
                        const myOwnAddress = thisIndex > -1;
                        if (!myOwnAddress) {
                          setDetailAddress("");
                        }
                        if (cart?.length > 0) {
                          setIsStar(false);
                          navigate("/Basket");
                        } else {
                          navigate("/OurServices");
                        }
                      }}
                      title={TEXT_CONFIRM[language]}
                    />
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
      ) : (
        <React.Fragment>
          {selectedLocation ? (
            <React.Fragment>
              <div
                className={`w-full px-4 md:px-10 xl:px-padding_read pb-0 mt-5 md:-mt-2 md:pb-8 bg-white  ${STYLE_MAX_WIDTH_DESKTOP} `}
              >
                <AddressMarker />
                <div
                  className={`relative ${STYLE_BUTTON_BLUE_DISABLED(language)}`}
                >
                  <div className={STYLE_ABSOLUTE_OBJECT_CENTER}>
                    {language === "TH"
                      ? "พื้นที่นี้ไม่เปิดให้บริการ"
                      : "Non-Service Area"}
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div
                className={`${STYLE_BOTTOM_BAR}  ${STYLE_MAX_WIDTH_DESKTOP} `}
              >
                <div
                  className={`relative ${STYLE_BUTTON_BLUE_DISABLED(language)}`}
                >
                  <div
                    style={{
                      width: "max-content",
                    }}
                    className={STYLE_ABSOLUTE_OBJECT_CENTER}
                  >
                    {language === "TH"
                      ? "ค้นหาที่อยู่ของคุณด้านบน"
                      : "Search for Your Address above"}
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

const SearchBox = ({ setIsStar }) => {
  const IsMobile = useIsMobile();

  const [search, setSearch] = React.useState("");

  const { language } = React.useContext(ContextLanguage);

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const selectedLocation = StoreSelectedLocation(
    (state) => state.selectedLocation
  );

  const [tempLocation, setTempLocation] = React.useState(false);

  const lopath = useLocation();
  const navigate = useNavigate();

  // const address = SystemStoreBasketAddress((state) => state.address);

  const onPlaceSelected = async (a, b) => {
    const completeProfilePage = window.location.pathname === "/CompleteProfile";

    if (!completeProfilePage) {
      let thisValue = {
        ...a,
      };

      if (thisValue?.geometry?.location?.lat()) {
        thisValue = {
          ...thisValue,
          lat: thisValue.geometry.location.lat(),
          lng: thisValue.geometry.location.lng(),
        };

        // setSelectedLocation({
        //   lat: "-62.7720728",
        //   lng: "-65.977308,721794",
        //   isAvilable: false,
        //   name: "Loading...",
        // });

        await NavbarClickLocationSearch({
          isPageAddress: lopath.pathname === "/Address",
          setSelectedLocation,
          setValue: setSearch,
          locationValue: a,
          refValue: b,
          navigate,
          setTempLocation,
        });

        setIsStar(false);

        if (ref.current) {
          ref.current.blur();
        }
      } else {
      }
    } else {
      return;
    }
  };

  const { ref } = usePlacesWidget({
    apiKey: "AIzaSyCBkCqnxwMUmT33843_vgeP1IXhxT1EVGE",
    onPlaceSelected: onPlaceSelected,
    options: {
      types: ["establishment", "geocode"],
      fields: [
        "address_components",
        "geometry",
        "place_id",
        "formatted_address",
        "name",
      ],
      componentRestrictions: { country: "th" },
    },
    inputAutocompleteValue: search,
  });

  // console.log("selectedLocation", selectedLocation);

  // console.log("ref", { ref });

  // if (selectedLocation?.name_google) {
  //   alert(selectedLocation?.name_google);
  // }

  return (
    <div
      style={{
        width: IsMobile ? "80vw" : "75%",
      }}
      className="rounded-md border border-[#3AB4ED] flex justify-between   top-3 md:top-5 z-40  absolute left-[56%] md:left-1/2 transform -translate-x-1/2 "
    >
      <ICON_LOCATION
        className={`absolute top-1/2 transform -translate-y-1/2 left-3 w-6 h-6 text-[#3AB4ED] `}
      />
      <input
        id="search-tracker"
        placeholder={
          selectedLocation?.name_google
            ? selectedLocation?.name_google
            : TEXT_ADDRESS_SEARCH[language]
        }
        className={`<mapref> pl-10 h-10 md:h-12 rounded-md w-full  focus:outline-none border-none font-medium text-sm lg:text-base ${STYLE_TITLE_MEDIUM} ${
          selectedLocation?.name_google
            ? " placeholder:text-laudry-gray-200 "
            : " placeholder:text-laundry-gray-50 "
        }  text-base ${
          language === "TH" ? "placeholder:font-NotoSansThai" : "font-Poppins"
        } `}
        ref={ref}
        // value={search}
        onFocus={(e) => {
          e.target.value = "";
        }}
        onBlur={(e) => {
          if (e.target.value === "") {
            e.target.value = selectedLocation?.name_google;
          }
        }}
        // value={search}
        // onFocus={() => {
        //   const findThis = document.querySelector(".pac-container");
        //   //set width of findThis !important to be equal to the width of the input ref
        //   // findThis.style.width = ref.current.offsetWidth + "px";
        //   // findThis.style.width = 200 + "px";
        // }}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
      />
    </div>
  );
};

const AddressMain = ({ setHistory, history }) => {
  const navigate = useNavigate();
  const locationPathName = useLocation();

  const { user } = useSelector((state) => state.auth);
  const [myAddress, setMyAddress] = React.useState([]);
  // const [isStar, setIsStar] = React.useState(false);

  const isStar = SystemStoreStar((state) => state.star);
  const setIsStar = SystemStoreStar((state) => state.setStar);

  const { language } = React.useContext(ContextLanguage);
  const IsMobile = useIsMobile();
  const size = useWindowSize();

  const selectedLocation = StoreSelectedLocation(
    (state) => state.selectedLocation
  );

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const refMap = React.useRef(null);

  React.useEffect(() => {
    document?.getElementById("first-div")?.scrollIntoView({
      block: "start",
    });
    if (user) {
      FunctionLoadMyAddress();
    }
  }, [user]);

  const FunctionLoadMyAddress = async () => {
    try {
      const { data } = await api.get(`/address?owner=${user?._id}`);
      setMyAddress(data.address);
    } catch (error) {
      console.error("FunctionLoadMyAddress : ", error);
    }
  };

  React.useEffect(() => {
    OurserviceFirstLoad();
  }, []);

  return (
    <React.Fragment>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      <Container style="text-gray-700 bg-white relative  h-full  pt-16 md:pt-[96px] ">
        <div
          className={`relative ${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB} mt-4 <27> bg-white`}
        >
          <div
            className={`absolute z-20 left-4  md:left-12 lg:left-[34px]  xl:left-[287px] top-4 md:top-6`}
          >
            <ProgramGoBackMap />
          </div>
          <div
            style={{
              width: IsMobile
                ? size.width?.length === "390"
                : size.width?.length === "100%",
              height: IsMobile ? "350px" : "424px",
              marginLeft: "auto",
              marginRight: "auto",
              marginBottom: IsMobile
                ? "unset"
                : selectedLocation
                ? "44px"
                : "unset",
              borderRadius: IsMobile ? "0px" : "16px",
              backgroundColor: "white",
            }}
            className={`ordershadow`}
          >
            <AwaitComponent>
              <SearchBox setIsStar={setIsStar} />
            </AwaitComponent>

            <GoogleMapsWrapper
              center={{
                lat: selectedLocation?.lat || 13.75156239312506,
                lng: selectedLocation?.lng || 100.55340835865732,
              }}
              ref={refMap}
              clickableIcons={false}
              isMarkerShown
              onClick={async (event) => {
                setIsStar(false);

                FunctionSetSelectedLocationFromLatLng(
                  event.latLng.lat(),
                  event.latLng.lng(),
                  setSelectedLocation
                );
              }}
              loadingElement={<div style={{ height: `100%`, width: "100%" }} />}
              containerElement={
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: IsMobile ? "0px" : "16px",
                    backgroundColor: "white",
                  }}
                />
              }
              mapElement={
                <div
                  className=""
                  style={{
                    height: `100%`,
                    width: "99.99%",
                    backgroundColor: "white",
                    borderRadius: IsMobile ? "0px" : "16px",
                  }}
                />
              }
              googleMapURL={googleMapURL}
              zoom={selectedLocation ? 15 : IsMobile ? 11 : 12}
              options={{
                mapTypeControl: false,
                panControl: false,
                streetViewControl: false,
                minZoom: 5,
                maxZoom: 20,
                draggableCursor: "pointer",
                fullscreenControl: false,
              }}
            >
              <Polyline
                path={lineBangkok}
                geodesic={true}
                options={{
                  strokeColor: "#ff2527",
                  strokeOpacity: 0.75,
                  strokeWeight: 2,
                  icons: [
                    {
                      offset: "0",
                      repeat: "20px",
                    },
                  ],
                }}
              />
              <Polyline
                path={linePattaya}
                geodesic={true}
                options={{
                  strokeColor: "#ff2527",
                  strokeOpacity: 0.75,
                  strokeWeight: 2,
                  icons: [
                    {
                      offset: "0",
                      repeat: "20px",
                    },
                  ],
                }}
              />

              {selectedLocation && (
                <Marker
                  icon={{
                    url: markerIcon,
                  }}
                  position={{
                    lat: Number(selectedLocation?.lat),
                    lng: Number(selectedLocation?.lng),
                  }}
                >
                  <InfoWindow>
                    <InfoConfirmContainer>
                      <div
                        className={` ${
                          language === "TH"
                            ? "  font-NotoSansThai "
                            : " font-Poppins "
                        } line-clamp-2 text-laundry-gray-100 font-semibold  `}
                      >
                        {selectedLocation?.name === "Loading..."
                          ? ""
                          : selectedLocation?.isAvailable
                          ? selectedLocation?.name
                          : "Non-Service Area"}
                      </div>
                    </InfoConfirmContainer>
                  </InfoWindow>
                </Marker>
              )}
            </GoogleMapsWrapper>
          </div>
        </div>
      </Container>
      <BottomBarAddress
        classNameBottomBar={STYLE_HEIGHT_BAR}
        title={TEXT_CONFIRM[language]}
        refetch={FunctionLoadMyAddress}
        isStar={isStar}
        setIsStar={setIsStar}
        onClick={() => {
          setIsStar(false);
        }}
      />
      {myAddress?.length > 0 && user && (
        <div
          className={`max-w-desktop mx-auto px-4 md:px-10 xl:px-padding_read pb-10`}
        >
          <div className={STYLE_SAVED_ADDRESSES}>
            {TEXT_SAVED_ADDRESSES[language]}
          </div>
          {myAddress?.map((row, index) => {
            return (
              <AddressRenderMyAddress
                key={`key-f-${index}`}
                row={row}
                index={index}
                language={language}
                location={locationPathName}
                navigate={navigate}
                FunctionLoadMyAddress={FunctionLoadMyAddress}
                setHistory={setHistory}
                setIsStar={setIsStar}
              />
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default AddressMain;
